<kz-app-header [title]="title"></kz-app-header>
<ion-content [fullscreen]="true">
  <div class="page-container">

    <app-kz-list-detail
      [list]="list"
      [columns]="columns"
      [loading]="loading"
      trackKey="id"
      [showActions]="true"
      [searchPlaceholder]="'tags.searchPlaceholder' | translate"
      [selectable]="true"
      [bulkActions]="bulkActions"
      (rowClick)="onUpdateItem($event)"
      (bulkAction)="onBulkAction($event)">

      <ion-button
        listActions
        fill="solid"
        size="small"
        (click)="presentItemForm(formModel)">
        <ion-icon slot="start" name="add-outline"></ion-icon>
        {{ 'tags.create' | translate }}
      </ion-button>

      <ng-template kzCell="name" let-row>
        <ion-text class="primary-text">{{ row.name | inlinetranslate }}</ion-text>
      </ng-template>

      <!-- Mobile card (≤767px) -->
      <ng-template kzCard let-row>
        <div class="kz-card-main">
          <div class="kz-card-title">{{ row.name | inlinetranslate }}</div>
        </div>
      </ng-template>

      <ng-template kzCell="actions" let-row>
        <list-item-actions
          [isApp]="false"
          buttonFill="outline"
          buttonSize="small"
          [item]="row"
          (update)="onUpdateItem(row)"
          (delete)="onDeleteItem(row)">
        </list-item-actions>
      </ng-template>
    </app-kz-list-detail>
  </div>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed" (click)="presentItemForm(formModel)">
    <ion-fab-button> <ion-icon name="add-circle"></ion-icon> </ion-fab-button>
  </ion-fab>
</ion-content>
